import {vpost} from "@/util/post";

export const poll = {
    list(pageSize, pageCurrent, keyword = "") {
        return vpost("/admin/poll/list", {pageSize, pageCurrent, keyword});
    },
    detail(number) {
        return vpost("/admin/poll/detail?number=" + encodeURIComponent(number));
    },
};
